export const FORMS_API_PATH = '/custom_forms/:formsxId/entries/';

export const DIRECTORY_BASE_PATH = '/directories/';
export const LIST_OF_DIRECTORIES_API_PATH = `${DIRECTORY_BASE_PATH}`;
export const DIRECTORY_CONFIG_API_PATH = `${DIRECTORY_BASE_PATH}:directoryId/`;

export const DIRECTORY_ITEM_API_PATH = `${DIRECTORY_CONFIG_API_PATH}items/`;

export const DIRECTORY_FACET_API_PATH = `${DIRECTORY_CONFIG_API_PATH}facets/:field_id/`;
